// src/constants.js
export const HIGHLIGHT_COLOR = '#7dd3fc';
export const PRIMARY_FONT = '"Caveat", cursive';
export const SECONDARY_FONT = '"Homemade Apple", cursive';
